import { Component, ChangeDetectionStrategy, signal, HostListener, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { MatSidenavModule } from '@angular/material/sidenav';
import { GlobalHeaderComponent } from '../../../../shared/components/layout/global-header/global-header';
import { GlobalFooterComponent } from '../../../../shared/components/layout/global-footer/global-footer';
import { GlobalSidebarComponent } from '../../../../shared/components/layout/global-sidebar/global-sidebar';
import { SidebarItem } from '../../../../shared/components/layout/global-sidebar/sidebar.model';
import { routeChainHidesSidebar } from '../../../../shared/components/layout/global-sidebar/sidebar-utils';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { BreadcrumbService } from '../../../../core/services/breadcrumb.service';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-accounting-layout',
  standalone: true,
  imports: [
    GlobalHeaderComponent,
    GlobalFooterComponent,
    GlobalSidebarComponent,
    RouterOutlet,
    MatSidenavModule,
    BreadcrumbComponent,
    TranslatePipe,
  ],
  templateUrl: './accounting-layout.component.html',
  styleUrls: ['./accounting-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingLayoutComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  hideSidebar = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => routeChainHidesSidebar(this.activatedRoute.snapshot)),
      startWith(routeChainHidesSidebar(this.activatedRoute.snapshot)),
    ),
    { requireSync: true },
  );

  protected readonly breadcrumbService = inject(BreadcrumbService);
  isMobile = signal(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  @HostListener('window:resize')
  onResize() {
    if (typeof window !== 'undefined') {
      this.isMobile.set(window.innerWidth <= 768);
      if (this.isMobile()) this.sidenavOpened.set(false);
      else this.sidenavOpened.set(true);
    }
  }
  sidenavOpened = signal(typeof window !== 'undefined' ? window.innerWidth > 768 : true);

  menuConfig: SidebarItem[] = [
    { id: 'overview', label: 'accounting.sidebar.overview', icon: 'grid_view', route: '/accounting', exact: true },
    { id: 'balanceSheet', label: 'accounting.sidebar.balanceSheet', icon: 'account_balance_wallet', route: '/accounting/balance-sheet', permission: 'accounting:balance_sheet:read' },
    { id: 'incomeExpenditure', label: 'accounting.sidebar.incomeExpenditure', icon: 'insights', route: '/accounting/income-expenditure', permission: 'accounting:income_expenditure:read' },
    { id: 'trialBalance', label: 'accounting.sidebar.trialBalance', icon: 'balance', route: '/accounting/trial-balance', permission: 'accounting:trial_balance:read' }
  ];

  toggleSidenav(): void {
    this.sidenavOpened.update(v => !v);
  }
}
